import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        toast.error("Authentication failed");
        navigate("/login");
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        const response = await fetch(`${BACKEND_URL}/api/auth/session`, {
          method: "POST",
          headers: {
            "X-Session-ID": sessionId,
            "Accept": "application/json",
            "Content-Type": "application/json"
          },
          credentials: "include",
          mode: "cors"
        });

        if (!response.ok) {
          throw new Error("Session creation failed");
        }

        const user = await response.json();
        
        // Store user info in localStorage as fallback for iOS Safari
        localStorage.setItem("user_info", JSON.stringify({
          user_id: user.user_id,
          name: user.name,
          role: user.role,
          email: user.email,
          logged_in: true
        }));
        
        toast.success(`Welcome back, ${user.name}!`);
        // Use window.location.replace for cleaner history on iOS
        window.location.replace("/dashboard");
      } catch (error) {
        console.error("Auth error:", error);
        toast.error("Authentication failed. Please try again.");
        navigate("/login");
      }
    };

    processSession();
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 via-slate-50 to-pink-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
        <p className="text-slate-600">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
